import { createFileRoute } from '@tanstack/react-router';

import { CustomerOrderCardPage } from '../../features/customer-orders';

// Подчёркивание в имени файла выводит карточку из-под списка: путь
// /orders/$orderId, но без вложения в экран «Заказы 1С».
export const Route = createFileRoute('/_app/orders_/$orderId')({
  staticData: { crumbs: ['Заказы 1С', 'Карточка заказа'] },
  component: CustomerOrderCardPage,
});
